import { Controller, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import { CustomFieldDef } from '../types';

const CustomFieldForm = ({ field }: { field: CustomFieldDef }) => {
  const { control, formState: { errors } } = useFormContext();
  const currentError = _.get(errors, field.key);

  return (
    <Controller
      name={field.key}
      control={control}
      render={({ field: renderField }) => (
        <>
          {field.render(renderField, currentError as any)}
          {currentError && (
            <p className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>
              {(currentError as any).message}
            </p>
          )}
        </>
      )}
    />
  );
};

export default CustomFieldForm;
